import { IConfigsType } from '../../types'

const fwWingstopPrepItemAdminSetting: IConfigsType = {
  'fw_wingstop-prep-item-admin-users-fc268486': {
    '/:brand/prep_item_admin_setting': {
      title: {
        type: 'title',
        title: 'Prep Item Admin Setting',
      },
      prepItemConfiguration: {
        type: 'ai-blackbox-wrapper',
        contentPartNames: ['fwWingstopPrepItemAdminSetting'],
      },
    },
  },
}

export default fwWingstopPrepItemAdminSetting
